export default {
  'certificates.title': 'Gestionar Certificados Digitales',
  'certificates.form.certificatePassword': 'Contraseña Certificado',
  'certificates.text.isPinEnabled': 'Habilitar PIN',
};
